import React, { Component } from 'react';
import Fecha from 'fecha';

import { Row, Col, Collapse } from 'react-bootstrap'

const marginRemove = {
	marginLeft: "0px",
	marginRight: "0px"
}

const titleStyle = {
	backgroundColor: "#004d99",
	color: "#fff",
	fontWeight: "bold",
	marginLeft: "0px",
	marginRight: "0px"
}

const padding = {
	padding: "15px",
	wordWrap: "break-word"
}

const noPadding = {
	padding: "0px",
	wordWrap: "break-word"
}


const leftClass = "col-lg-3 col-sm-3 col-4 border";
const rightClass = "col-lg-9 col-sm-9 col-8 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center";

export default class Signature extends Component {

	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	render() {
		return (
			<React.Fragment>

				<Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
					<Col style={padding} className="col-lg-12 col-sm-12 col-12">
						<Row style={marginRemove}>
							<Col className="col-lg-11 col-sm-11 col-10">
								<Row>
									<Col style={{ "paddingLeft": "5px" }} className="col-3">
										Signature/Seal ID:
									</Col>
									<Col className="col-9">
										{this.props.index + 1}. {this.props.data.id}
									</Col>
								</Row>
							</Col>
							<Col className={sIdClass} style={{ "paddingRight": "0px" }}>
								{this.state.open ?
									<i className="material-icons align-middle" aria-hidden="true">expand_less</i>
									:
									<i className="material-icons align-middle" aria-hidden="true">expand_more</i>
								}
							</Col>
						</Row>
					</Col>
				</Row>

				<Collapse in={this.state.open}>
					<div>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Counter Signature:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.counterSignature)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Signature Filename:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.signatureFilename)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Parent ID:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.parentId)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Error Message:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.errorMessage)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Date Time:</Col>
							<Col style={padding} className={rightClass}>
								{this.props.data.dateTime == null ?
									"-"
									:
									Fecha.format(new Date(this.props.data.dateTime), 'DD.MM.YYYY. [at] HH:mm')
								}
							</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Signature Format:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.signatureFormat)}</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Structural Validation</Col>
							{this.props.data.structuralValidation == null ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Valid:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.structuralValidation.valid)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Message:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.structuralValidation.message)}
										</Col>
									</Row>
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Digest Matchers</Col>
							{this.props.data.digestMatchers.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.digestMatchers.map((digestMatchers, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Digest Method:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.digestMethod)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Digest Value:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.digestValue)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Data Found:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.dataFound)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Data Intact:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.dataIntact)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Type:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.type)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Name:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(digestMatchers.name)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Basic Signature</Col>
							{this.props.data.basicSignature == null ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Encryption Algo Used To Sign This Token:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.encryptionAlgoUsedToSignThisToken)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Key Length Used To Sign This Token:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.keyLengthUsedToSignThisToken)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Digest Algo Used To Sign This Token:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.digestAlgoUsedToSignThisToken)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Mask Generation Function Used To Sign This Token
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.maskGenerationFunctionUsedToSignThisToken)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Signature Intact:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.signatureIntact)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Signature Valid:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.basicSignature.signatureValid)}
										</Col>
									</Row>
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Signing Certificate:</Col>
							{this.props.data.signingCertificate == null ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Attribute Present:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signingCertificate.attributePresent)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Digest Value Present:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signingCertificate.digestValuePresent)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Digest Value Match:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signingCertificate.digestValueMatch)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Issuer Serial Match:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signingCertificate.issuerSerialMatch)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											ID:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signingCertificate.id)}
										</Col>
									</Row>
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Certificate Chain:</Col>
							{this.props.data.certificateChain.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.certificateChain.map((certificateChain, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Source:
									</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(certificateChain.source)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													ID:
									</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(certificateChain.id)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Content Type:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.contentType)}</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Content Identifier:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.contentIdentifier)}</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Content Hints:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.contentHints)}</Col>
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Signature Production Place:</Col>
							{this.props.data.signatureProductionPlace == null ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Address:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signatureProductionPlace.address)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Postal Code:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signatureProductionPlace.postalCode)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											City:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signatureProductionPlace.city)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											State or Province:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signatureProductionPlace.stateOrProvince)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Country:
									</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.signatureProductionPlace.countryName)}
										</Col>
									</Row>
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Commitment Type Indication:</Col>
							{this.props.data.commitmentTypeIndication.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.commitmentTypeIndication.map((commitmentTypeIndication, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className="border">
													{dataValue(commitmentTypeIndication)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Claimed Roles:</Col>
							{this.props.data.claimedRoles.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.claimedRoles.map((claimedRoles, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className="border">
													{dataValue(claimedRoles)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Certified Roles:</Col>
							{this.props.data.certifiedRoles.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.certifiedRoles.map((certifiedRoles, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Category:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(certifiedRoles.category)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Certified Role:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(certifiedRoles.certifiedRole)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Not Before:
												</Col>
												<Col style={padding} className={rightClass}>
													{certifiedRoles.notBefore == null ?
														"-"
														:
														Fecha.format(new Date(certifiedRoles.notBefore), 'DD.MM.YYYY. [at] HH:mm')
													}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Not After:
												</Col>
												<Col style={padding} className={rightClass}>
													{certifiedRoles.notAfter == null ?
														"-"
														:
														Fecha.format(new Date(certifiedRoles.notAfter), 'DD.MM.YYYY. [at] HH:mm')
													}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Policy:</Col>
							{this.props.data.policy == null ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											ID:
											</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.policy.id)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Notice:
										</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.policy.notice)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Processing Error:
											</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.policy.processingError)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											URL:
											</Col>
										<Col style={padding} className={rightClass}>
											{dataValue(this.props.data.policy.url)}
										</Col>
									</Row>
									<Row style={marginRemove}>
										<Col style={padding} className={leftClass}>
											Digest Algo and Value:
										</Col>
										{this.props.data.policy.digestAlgoAndValue == null ?
											<Col style={padding} className={rightClass}>-</Col>
											:
											<Col style={noPadding} className={rightClass}>
												<Row style={marginRemove}>
													<Col style={padding} className={leftClass}>
														Digest Method:
													</Col>
													<Col style={padding} className={rightClass}>
														{dataValue(this.props.data.policy.digestAlgoAndValue.digestMethod)}
													</Col>
												</Row>
												<Row style={marginRemove}>
													<Col style={padding} className={leftClass}>
														Digest Value:
													</Col>
													<Col style={padding} className={rightClass}>
														{dataValue(this.props.data.policy.digestAlgoAndValue.digestValue)}
													</Col>
												</Row>
											</Col>
										}
									</Row>

								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Timestamps:</Col>
							{this.props.data.timestamps.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.timestamps.map((timestamps, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Production Time:
											</Col>
												<Col style={padding} className={rightClass}>
													{timestamps.productionTime == null ?
														"-"
														:
														Fecha.format(new Date(timestamps.productionTime), 'DD.MM.YYYY. [at] HH:mm')
													}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>Digest Matchers</Col>
												{timestamps.digestMatcher.length == 0 ?
													<Col style={padding} className={rightClass}>-</Col>
													:
													<Col className={rightClass} style={noPadding}>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Digest Method:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.digestMethod)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Digest Value:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.digestValue)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Data Found:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.dataFound)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Data Intact:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.dataIntact)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Type:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.type)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Name:
															</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.digestMatcher.name)}
															</Col>
														</Row>
													</Col>
												}
											</Row>

											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>Basic Signature</Col>
												{timestamps.basicSignature == null ?
													<Col style={padding} className={rightClass}>-</Col>
													:
													<Col className={rightClass} style={noPadding}>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Encryption Algo Used To Sign This Token:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.encryptionAlgoUsedToSignThisToken)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Key Length Used To Sign This Token:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.keyLengthUsedToSignThisToken)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Digest Algo Used To Sign This Token:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.digestAlgoUsedToSignThisToken)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Mask Generation Function Used To Sign This Token
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.maskGenerationFunctionUsedToSignThisToken)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Signature Intact:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.signatureIntact)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Signature Valid:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.basicSignature.signatureValid)}
															</Col>
														</Row>
													</Col>
												}
											</Row>

											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>Signing Certificate:</Col>
												{timestamps.signingCertificate == null ?
													<Col style={padding} className={rightClass}>-</Col>
													:
													<Col className={rightClass} style={noPadding}>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Attribute Present:
													</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.signingCertificate.attributePresent)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Digest Value Present:
													</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.signingCertificate.digestValuePresent)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Digest Value Match:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.signingCertificate.digestValueMatch)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																Issuer Serial Match:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.signingCertificate.issuerSerialMatch)}
															</Col>
														</Row>
														<Row style={marginRemove}>
															<Col style={padding} className={leftClass}>
																ID:
												</Col>
															<Col style={padding} className={rightClass}>
																{dataValue(timestamps.signingCertificate.id)}
															</Col>
														</Row>
													</Col>
												}
											</Row>

											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>Certificate Chain:</Col>
												{timestamps.certificateChain.length == 0 ?
													<Col style={padding} className={rightClass}>-</Col>
													:
													<Col className={rightClass} style={noPadding}>
														{timestamps.certificateChain.map((certificateChain, i) => {
															return <React.Fragment key={i}>
																<Row style={marginRemove}>
																	<Col style={padding} className={leftClass}>
																		Source:
															</Col>
																	<Col style={padding} className={rightClass}>
																		{dataValue(certificateChain.source)}
																	</Col>
																</Row>
																<Row style={marginRemove}>
																	<Col style={padding} className={leftClass}>
																		ID:
															</Col>
																	<Col style={padding} className={rightClass}>
																		{dataValue(certificateChain.id)}
																	</Col>
																</Row>
															</React.Fragment>
														})}
													</Col>
												}
											</Row>

											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>Timestamped Objects:</Col>
												{timestamps.timestampedObjects.length == 0 ?
													<Col style={padding} className={rightClass}>-</Col>
													:
													<Col className={rightClass} style={noPadding}>
														{timestamps.timestampedObjects.map((timestampedObjects, i) => {
															return <React.Fragment key={i}>
																<Row style={marginRemove}>
																	<Col style={padding} className={leftClass}>
																		Digest Algo and Value:
															</Col>
																	{timestampedObjects.digestAlgoAndValue == null ?
																		<Col style={padding} className={rightClass}>-</Col>
																		:
																		<Col style={noPadding} className={rightClass}>
																			<Row style={marginRemove}>
																				<Col style={padding} className={leftClass}>
																					Digest Method:
																		</Col>
																				<Col style={padding} className={rightClass}>
																					{dataValue(timestampedObjects.digestAlgoAndValue.digestMethod)}
																				</Col>
																			</Row>
																			<Row style={marginRemove}>
																				<Col style={padding} className={leftClass}>
																					Digest Value:
																		</Col>
																				<Col style={padding} className={rightClass}>
																					{dataValue(timestampedObjects.digestAlgoAndValue.digestValue)}
																				</Col>
																			</Row>
																		</Col>
																	}
																</Row>
																<Row style={marginRemove}>
																	<Col style={padding} className={leftClass}>
																		ID:
															</Col>
																	<Col style={padding} className={rightClass}>
																		{dataValue(timestampedObjects.id)}
																	</Col>
																</Row>
																<Row style={marginRemove}>
																	<Col style={padding} className={leftClass}>
																		Category:
															</Col>
																	<Col style={padding} className={rightClass}>
																		{dataValue(timestampedObjects.category)}
																	</Col>
																</Row>
															</React.Fragment>
														})}
													</Col>
												}
											</Row>

											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Base 64 Encoded:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(timestamps.base64Encoded)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													ID:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(timestamps.id)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Type:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(timestamps.type)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>

						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Signature Scopes:</Col>
							{this.props.data.signatureScopes.length == 0 ?
								<Col style={padding} className={rightClass}>-</Col>
								:
								<Col className={rightClass} style={noPadding}>
									{this.props.data.signatureScopes.map((signatureScopes, i) => {
										return <React.Fragment key={i}>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Value:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(signatureScopes.value)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Name:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(signatureScopes.name)}
												</Col>
											</Row>
											<Row style={marginRemove}>
												<Col style={padding} className={leftClass}>
													Scope:
											</Col>
												<Col style={padding} className={rightClass}>
													{dataValue(signatureScopes.scope)}
												</Col>
											</Row>
										</React.Fragment>
									})}
								</Col>
							}
						</Row>


					</div>
				</Collapse>
			</React.Fragment >
		);
	}
}

function dataValue(value) {
	return <React.Fragment>
		{value == null ?
			"-"
			:
			<React.Fragment>{'' + value}</React.Fragment>
		}
	</React.Fragment>
}